<div class="rating-container">

  @for (rating of ratings; track rating) {
    <div
      class="rating-bar"
      [ngClass]="{
        'rating-bar__filled': rating <= selectedRate,
        'rating-bar__outlined': rating > selectedRate
      }"
    ></div>
  }
</div>